module.exports = __webpack_public_path__ + "static/media/12.1d11c660.jpg";